export let Events = /*#__PURE__*/function (Events) {
  Events["BeforeDragStart"] = "fly:drag:start:before";
  Events["DragStart"] = "fly:drag:start";
  Events["DragMove"] = "fly:drag:move";
  Events["DragEnd"] = "fly:drag:end";
  Events["DragOver"] = "fly:drag:over";
  Events["DragEnter"] = "fly:drag:enter";
  Events["DragLeave"] = "fly:drag:leave";
  Events["Drop"] = "fly:drag:drop";
  Events["CloneCreate"] = "fly:clone:create";
  Events["CloneDestroy"] = "fly:clone:destroy";
  Events["DragSort"] = "fly:drag:sort";
  return Events;
}({});
export function triggerEvent(element, eventName, options) {
  let event = new CustomEvent(eventName, {
    detail: options
  });
  element.dispatchEvent(event);
  return event;
}